import type { SVGProps } from 'react'
const SvgSyPaperPlus = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path
			fillRule="evenodd"
			d="M8.084 2.012C5.62 2.012 3.5 3.999 3.5 6.49v10.85c0 2.557 2.04 4.525 4.584 4.525h7.988c2.477 0 4.48-2.06 4.48-4.525V8.037a.75.75 0 0 0-.208-.52l-5.067-5.275a.75.75 0 0 0-.54-.23zm0 1.5h6.332l4.637 4.828v9c0 1.655-1.337 3.025-2.98 3.025h-7.99C6.275 20.365 5 19.135 5 17.34V6.49c0-1.629 1.43-2.978 3.084-2.978"
			clipRule="evenodd"
		/>
		<path d="M14.473 2a.75.75 0 0 0-.75.75v2.91a3.336 3.336 0 0 0 3.318 3.324l1.838.002h.637c.161 0 .184.004.33-.006a.75.75 0 0 0 .699-.796.75.75 0 0 0-.797-.7c.1-.006-.08.002-.238.002h-.631c-.512 0-1.176 0-1.834-.002a1.814 1.814 0 0 1-1.822-1.824V2.75a.75.75 0 0 0-.75-.75" />
		<path
			fillRule="evenodd"
			d="M12.594 10.464a.75.75 0 1 0-1.5 0v1.7h-1.7a.75.75 0 1 0 0 1.5h1.7v1.701a.75.75 0 0 0 1.5 0v-1.7h1.7a.75.75 0 0 0 0-1.5h-1.7z"
			clipRule="evenodd"
			opacity={0.4}
		/>
	</svg>
)
export default SvgSyPaperPlus
